import { getCountryListApi } from '@/api/independentMarketing.js';

const state = {
  countryList: [],
  selectCountry: null,
};

const getters = {
  GET_COUNTRY_LIST: state => state.countryList,
  GET_SELECT_COUNTRY: state => state.selectCountry,
};

const mutations = {
  SET_COUNTRY_LIST: (state, data) => {
    state.countryList = data;
  },
  SET_SELECT_COUNTRY: (state, data) => {
    state.selectCountry = data;
  },
};

const actions = {
  POST_COUNTRY_LIST: ({ commit }) => {
    getCountryListApi().then(res => {
      const { code, data } = res || {};
      if (code === 200 && data?.length) {
        commit('SET_COUNTRY_LIST', data);
      }
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
